module.exports = __webpack_public_path__ + "static/media/Problems_Growing_Children-12-l.335dabb5.pdf";